var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31.5,
    r: 31,
    fill: "#2A2A2A",
    stroke: "#4E4E4E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_168_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.415 30.715C48.415 34.0983 47.2017 36.8867 44.775 39.08L48.415 45.24H40.47C39.42 45.24 38.3817 45.0417 37.355 44.645C36.3517 44.2483 35.5117 43.7 34.835 43C33.7383 43.1167 32.735 43.175 31.825 43.175C28.6983 43.175 25.875 42.6967 23.355 41.74C20.8583 40.7833 18.875 39.3717 17.405 37.505C15.9583 35.615 15.235 33.3517 15.235 30.715C15.235 28.1017 15.9583 25.8617 17.405 23.995C18.875 22.1283 20.87 20.7167 23.39 19.76C25.91 18.78 28.7217 18.29 31.825 18.29C34.9283 18.29 37.74 18.78 40.26 19.76C42.78 20.7167 44.7633 22.1283 46.21 23.995C47.68 25.8617 48.415 28.1017 48.415 30.715ZM31.825 41.11C32.8283 41.11 33.5633 40.6667 34.03 39.78C34.4267 39.1033 34.695 37.9017 34.835 36.175C34.905 35.265 34.94 33.445 34.94 30.715C34.94 28.335 34.8817 26.3867 34.765 24.87C34.695 23.47 34.4383 22.4083 33.995 21.685C33.5283 20.7983 32.805 20.355 31.825 20.355C30.8683 20.355 30.145 20.7983 29.655 21.685C29.2583 22.385 29.0017 23.4467 28.885 24.87C28.7683 26.0133 28.71 27.9617 28.71 30.715C28.71 33.5383 28.7567 35.3583 28.85 36.175C28.9667 37.8783 29.2233 39.08 29.62 39.78C30.11 40.6667 30.845 41.11 31.825 41.11Z",
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_168_421",
    x: 11.2349,
    y: 18.29,
    width: 41.1802,
    height: 34.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_168_421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_168_421",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/Q.6720d1d6273f6d0f828cf48c1014f553.svg";
export { ForwardRef as ReactComponent };